// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"de82555b","393":"5f303490","972":"fe5a1476"}[chunkId] + ".chunk.js";
};